import { Box, BoxProps, ColorOptions, ModalDialog, SpacerNew, TextNew } from '@jfs/ui-new'
import { ButtonNew } from '../../../components/AdminButton'
import { useCallback, useEffect, useState } from 'react'

import { useNavigation } from '@react-navigation/core'
import React from 'react'
import { NewVerticalStepIndicator } from '../../../components/NewVerticalStepIndicator'
import { useLazyApiData, useStores } from '../../../data/store'
//import { onboardingSampleData } from '../../../mocks/onboardingSampleData'
import { compareArray, zoomOutIfRequire } from '../../../utils'
import { EmType } from '../../EntityManagement'
import { StatusComp } from '../../EntityManagement/Onboarding/CreationStatus/StatusComp'
import { EntityOnboardingForm } from './EntityOnboardingForm'
import { EntityOnboardingHeader } from './EntityOnboardingHeader'
import { FullScreenLoader } from './comps/FullScreenLoader'

const OnboardEntity = () => {
  const [currentStep, setCurrentStep] = useState(1)
  const [totalFilledStep, setTotalFilledStep] = useState(1)
  const [shouldShowConfirmDialog, setShouldShowConfirmDialog] = React.useState(false)
  const [formValidationStatus, setFormValidationStatus] = useState(ENTITY_ONBOARDING_STEPS.map(() => false))
  const onStepPressed = useCallback((pressedStep: any) => {
    console.log('pressedStep=', pressedStep)
    setCurrentStep(pressedStep)
  }, [])
  const [isLoading, setIsLoading] = React.useState('')
  const navigation = useNavigation()

  const { createWorkItem } = useStores((store) => ({
    createWorkItem: store.entityOnboarding.createWorkItem,
    setMessage: store.message.setMessage,
  }))
  const nativeID = 'onboardContainer'
  useEffect(() => {
    zoomOutIfRequire(nativeID)
  }, [])

  const [createWorkItemApi, createWorkItemHandler] = useLazyApiData(createWorkItem)
  const [lastRequest, setLastRequest] = useState({})
  const [lastDedupeData, setLastDedupeData] = useState({})

  const onSubmit = useCallback(
    (values, ddData) => {
      createWorkItemApi(values, ddData, lastRequest, lastDedupeData)
    },
    [createWorkItemApi, lastRequest, lastDedupeData],
  )
  useEffect(() => {
    if (createWorkItemHandler.state === 'rejected') {
      if (createWorkItemHandler.data?.dedupeFound) {
        setLastRequest(createWorkItemHandler.data.lastRequest)
        setLastDedupeData(createWorkItemHandler.data.dedupeResponse)
      }
    } else if (createWorkItemHandler.state === 'fulfilled') {
      setLastRequest({})
      setLastDedupeData({})
    }
  }, [createWorkItemHandler.state])

  const onOnbardNewPress = () => {
    navigation.reset({
      index: 0,
      routes: [{ name: 'onboardEntity' }],
    })
  }

  const onConfirmPress = useCallback(() => {
    navigation.reset({
      index: 0,
      routes: [{ name: 'makerMyEntityQueue' }],
    })
  }, [navigation])

  console.log('createWorkItemHandler resp=', createWorkItemHandler)

  const onCancelOnBoarding = useCallback(() => {
    setShouldShowConfirmDialog(true)
  }, [])
  const initialValues = { allowParentFeePackageId: 'No', onboardingChannel: 'Admin portal' }
  return (
    <Box h="100%" width={'100%'} overflow={'hidden'} padding={5}>
      <Box {...styles.container} nativeID={nativeID}>
        {createWorkItemHandler?.state === 'fulfilled' && (
          <StatusComp
            type={EmType.createSingleEntity}
            isCreateSuccess={true}
            onBackPress={undefined}
            applicationId={createWorkItemHandler.data?.applicationId}
            businessName={createWorkItemHandler.data?.businessName}
            isUserCreationPressed={false}
            navigateToCreateGroup={onOnbardNewPress}
            showSuccess={true}
            navigateToMyAppQueue={onConfirmPress}
          />
        )}
        <EntityOnboardingHeader title={'Add New Merchant'} />
        <Box {...styles.innerContainer}>
          <Box w={220}>
            <NewVerticalStepIndicator
              currentStep={currentStep}
              submitState={''}
              formValidationStatus={formValidationStatus}
              steps={ENTITY_ONBOARDING_STEPS}
              totalFilledStep={totalFilledStep}
              onStepPressed={onStepPressed}
            />
          </Box>
          <Box flex={1}>
            <EntityOnboardingForm
              initialValues={initialValues}
              currentStep={currentStep}
              allStepsValidationStatus={formValidationStatus}
              setAllStepValidationStatus={(allStepValidationStatus) => {
                const isChanged = !compareArray(allStepValidationStatus, formValidationStatus)
                if (isChanged) {
                  setFormValidationStatus([...allStepValidationStatus])
                }
              }}
              onStepPressed={(pressedStep) => {
                setTotalFilledStep(pressedStep)
                onStepPressed(pressedStep)
              }}
              onSubmit={onSubmit}
              onCancelOnBoarding={onCancelOnBoarding}
            />
          </Box>
        </Box>
      </Box>
      <FullScreenLoader show={createWorkItemHandler?.state === 'pending'} />
      <ConfirmCancelOnboardingDialog
        show={shouldShowConfirmDialog}
        onDismiss={() => setShouldShowConfirmDialog(false)}
        onConfirmPress={onConfirmPress}
      />
    </Box>
  )
}

const styles = {
  container: {
    h: '100%',
    borderRadius: 8,
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    h: '100%',
  } as BoxProps,
  innerContainer: {
    flexDirection: 'row',
    flex: 1,
  } as BoxProps,
}

export default OnboardEntity

export const ENTITY_ONBOARDING_STEPS = [
  'Business Contact',
  'Authorised Signatory',
  'Business Details',
  'Other Business Details',
  'Bank Details',
  'Document Upload',
  'Fee/Package Details',
]

const ConfirmCancelOnboardingDialog = ({ show, onDismiss, onConfirmPress }: any) => {
  return (
    <ModalDialog show={show} onDismiss={onDismiss} type="CenteredWrap">
      <Box width={'30vw'} backgroundColor={'WHITE'} borderRadius={4} ph={24} alignItems={'center'}>
        <SpacerNew size={20} />
        <TextNew fontSize={24} fontFamily="jioType-bold">
          Are you sure?
        </TextNew>
        <SpacerNew size={30} />
        <TextNew fontSize={14} fontFamily="jioType-light" color={'BLACK_75'}>
          you will lose all information you have filled do you wish to proceed
        </TextNew>

        <SpacerNew size={40} />

        <Box flexDirection={'row'} marginBottom={10}>
          <ButtonNew
            type={'secondary'}
            borderColor={'PRIMARY'}
            onPress={onDismiss}
            title={'Cancel'}
            height={32}
            width={160}
          />
          <SpacerNew size={40} direction="horizontal" />
          <ButtonNew
            type={'primary'}
            color={'PRIMARY'}
            onPress={onDismiss}
            title={'Proceed'}
            height={32}
            width={160}
            onPress={onConfirmPress}
          />
        </Box>
      </Box>
    </ModalDialog>
  )
}
